export default function PriceHistogram({ histogram, itemMinPrice, itemMaxPrice, itemFilterActive }) {
  if (!histogram?.length) return null;
  const maxCount = Math.max(...histogram.map(b => b.count || 0), 1);
  const LABELS   = ["<$5","$5-10","$10-20","$20-30","$30-40","$40-50","$50-60","$60+"];

  return (
    <div style={{ marginBottom: 12, padding: "12px 12px 8px", background: "#f8fafc", borderRadius: 12 }}>
      <div style={{ fontSize: 10, color: "#64748b", marginBottom: 8, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.5px" }}>
        Requests by Price
      </div>
      <div style={{ display: "flex", alignItems: "flex-end", gap: 3, height: 50 }}>
        {histogram.map((bucket, i) => {
          const inRange = itemFilterActive
            ? (bucket.lo < (itemMaxPrice || 9999) && bucket.hi > (itemMinPrice || 0))
            : true;
          const height = bucket.count === 0 ? 2 : Math.max(4, (bucket.count / maxCount) * 50);
          return (
            <div key={i}
              title={`${LABELS[i]}: ${bucket.count} item${bucket.count !== 1 ? "s" : ""}`}
              style={{
                flex: 1, height, borderRadius: "3px 3px 0 0",
                background: bucket.count === 0 ? "#e2e8f0" : inRange ? "#f97316" : "#cbd5e1",
                transition: "all .3s",
              }}
            />
          );
        })}
      </div>
      <div style={{ display: "flex", gap: 3, marginTop: 5 }}>
        {LABELS.map((label, i) => (
          <span key={i} style={{
            flex: 1, textAlign: "center", fontSize: 7, fontWeight: 700,
            color: itemFilterActive && histogram[i] &&
              (histogram[i].lo < (itemMaxPrice||9999) && histogram[i].hi > (itemMinPrice||0))
              ? "#f97316" : "#94a3b8",
          }}>{label}</span>
        ))}
      </div>
    </div>
  );
}